import React, { useRef, useState } from 'react';
import { X, UploadCloud, FileSpreadsheet, Loader2 } from 'lucide-react';

export default function BizExcelUploadModal({ isOpen, onClose, onUpload, isUploading }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setSelectedFile(file);
  };

  const handleSubmit = () => {
    if (selectedFile) {
      onUpload(selectedFile);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl animate-in zoom-in-95 duration-200">
        
        {/* 모달 헤더 */}
        <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4">
          <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
            <FileSpreadsheet className="h-5 w-5 text-green-600" />
            사업장 마스터 엑셀 업로드
          </h3>
          <button onClick={handleClose} disabled={isUploading} className="text-slate-400 hover:text-slate-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* 모달 바디 */}
        <div className="p-6">
          <p className="mb-4 text-sm text-slate-500">
            다운로드 받으신 양식에 맞게 작성된 엑셀(.xlsx, .csv) 파일을 업로드 해주세요. 기존 데이터는 사업자번호 기준으로 업데이트됩니다.
          </p>

          <div 
            className={`mt-2 flex justify-center rounded-lg border border-dashed px-6 py-10 transition-colors ${selectedFile ? 'border-green-400 bg-green-50' : 'border-slate-300 hover:border-blue-400 hover:bg-slate-50'}`}
          >
            <div className="text-center">
              <UploadCloud className={`mx-auto h-12 w-12 ${selectedFile ? 'text-green-500' : 'text-slate-300'}`} />
              <div className="mt-4 flex text-sm leading-6 text-slate-600 justify-center">
                <label className="relative cursor-pointer rounded-md bg-white font-semibold text-blue-600 focus-within:outline-none hover:text-blue-500">
                  <span>{selectedFile ? '다른 파일 선택' : '파일 파일 선택'}</span>
                  <input ref={fileInputRef} type="file" className="sr-only" accept=".xlsx, .xls, .csv" onChange={handleFileChange} disabled={isUploading} />
                </label>
                <p className="pl-1">{selectedFile ? '완료' : '또는 드래그 앤 드롭'}</p>
              </div>
              <p className="text-xs leading-5 text-slate-500">
                {selectedFile ? <span className="font-bold text-slate-700">{selectedFile.name}</span> : 'CSV, XLSX up to 10MB'}
              </p>
            </div>
          </div>
        </div>

        {/* 모달 푸터 */}
        <div className="flex items-center justify-end gap-3 rounded-b-2xl bg-slate-50 px-6 py-4 border-t border-slate-100">
          <button onClick={handleClose} disabled={isUploading} className="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-200 transition-colors">
            취소
          </button>
          <button 
            onClick={handleSubmit} 
            disabled={!selectedFile || isUploading}
            className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 disabled:opacity-50 transition-colors"
          >
            {isUploading && <Loader2 className="h-4 w-4 animate-spin" />}
            {isUploading ? '업로드 중...' : '데이터 등록'}
          </button>
        </div>

      </div>
    </div>
  );
}